import L from 'leaflet'
import * as turf from '@turf/turf';

export function getParcelBounds(parcel) {
  let southWest = L.latLng(parcel['bbox'][1], parcel['bbox'][0]),
    northEast = L.latLng(parcel['bbox'][3], parcel['bbox'][2])
  return L.latLngBounds(southWest, northEast)
}

export function computeLatLngBoundsFromGeojson(geojson) {
  const latLngList = [];

  if (geojson && geojson.geometry && geojson.geometry.type === 'Polygon') {
    geojson.geometry.coordinates[0].forEach((coord) => {
      latLngList.push(L.latLng(coord[1], coord[0]));
    });
  }

  return L.latLngBounds(latLngList);
}

export function createCanvasForParcel(
  parcel,
  imageUrl,
  selectedResolution,
  layer,
  callback = () => { },
  stats = undefined
) {
  const bounds = getParcelBounds(parcel)

  var canvas = document.createElement('canvas')
  var context = canvas.getContext('2d')

  var image = new Image()
  image.onload = function() {
    canvas.width = this.width
    canvas.height = this.height
    context.drawImage(this, 0, 0)

    callback()
  }

  let url = `${process.env.REACT_APP_BASE_URL_IMAGES}${selectedResolution.instance_id}?`
  image.src = `${url}${imageUrl}`
  image.crossOrigin = 'anonymous'

  return {
    bounds: bounds,
    parcelUrl: imageUrl,
    parcel: parcel,
    canvas: canvas,
    context: context,
    stats: stats,
    layer: layer,
  }
}


function findNumbersInString(str) {
  let regex = /[-+]?\d*\.?\d+/g;
  return str.match(regex);
}

// Valid coordinates in the EPSG 4326 system
export function isValidCoordinate(coordinatesString) {
  const parseString = findNumbersInString(coordinatesString)

  if (parseString?.length !== 2) return false

  const latitude = parseFloat(parseString[0])
  const longitude = parseFloat(parseString[1])
  // Check if latitude and longitude are numbers
  if (typeof latitude !== 'number' || typeof longitude !== 'number') {
    return false
  }

  // Check if latitude is in the valid range (-90 to 90 degrees)
  if (latitude < -90 || latitude > 90) {
    return false
  }

  // Check if longitude is in the valid range (-180 to 180 degrees)
  if (longitude < -180 || longitude > 180) {
    return false
  }

  // If both latitude and longitude are valid, return true
  return true
}

export function getCoordinatesFromString(coordinatesString) {
  const parseString = findNumbersInString(coordinatesString)

  if (parseString?.length !== 2) return null

  return parseString
}


/**
 * Checks for overlapping polygons in a GeoJSON FeatureCollection.
 * Adds an 'overlapping' property to features that overlap with others.
 * 
 * @param {Array} features - Array of GeoJSON features.
 * @returns {Array} - Updated array of features with 'overlapping' property.
 */
export function detectOverlappingFeatures(features) {
  const updatedFeatures = features.map(feature => ({
    ...feature,
    properties: {
      ...feature.properties,
      overlapping: false, // Initialize the overlapping property
    },
  }));

  for (let i = 0; i < updatedFeatures.length; i++) {
    for (let j = i + 1; j < updatedFeatures.length; j++) {
      const poly1 = turf.polygon(updatedFeatures[i].geometry.coordinates);
      const poly2 = turf.polygon(updatedFeatures[j].geometry.coordinates);

      if (turf.intersect(poly1, poly2)) {
        updatedFeatures[i].properties.overlapping = true;
        updatedFeatures[j].properties.overlapping = true;
      }
    }
  }

  return updatedFeatures;
};
